'use strict';

var React = require('react');

var SvgTransactionFeeRupeeMajor = function SvgTransactionFeeRupeeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 13a1 1 0 0 1 0 2c-2.206 0-4-1.794-4-4v-7h-1.184a2.997 2.997 0 0 1-2.816 2c-1.654 0-3-1.346-3-3s1.346-3 3-3c1.302 0 2.401.839 2.816 2h8.368a2.997 2.997 0 0 1 2.816-2c1.654 0 3 1.346 3 3s-1.346 3-3 3a2.995 2.995 0 0 1-2.815-2h-5.185v7c0 1.103.897 2 2 2zm4.848 2.562 2.08 2.761a1 1 0 1 1-1.596 1.204l-3.01-3.993a1 1 0 0 1 1.259-1.49c.233.037.492.056.776.056.702 0 1.242-.478 1.494-1.235h-3.101a.75.75 0 1 1 0-1.5h3.23c-.091-.72-.395-1.283-.844-1.58h-2.136a1 1 0 1 1 0-2h5a1 1 0 1 1 0 2h-.944c.232.467.38 1.004.431 1.58h.763a.75.75 0 1 1 0 1.5h-.849c-.298 1.407-1.21 2.486-2.553 2.697z"
  }));
};

exports.SvgTransactionFeeRupeeMajor = SvgTransactionFeeRupeeMajor;
